import React from "react";

const LOGOS = [
  "Startups",
  "D2C Brands",
  "Corporates",
  "Enterprises",
  "Events",
  "Studios",
  "Founders",
  "Creators",
];

export const Marquee = () => {
  const items = [...LOGOS, ...LOGOS, ...LOGOS];
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-[#000000] border-y border-white/5 py-8 overflow-hidden"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {items.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-12 px-8 text-white/30 hover:text-fuchsia-400 transition-colors"
          >
            <span className="font-display text-2xl md:text-3xl font-light tracking-[0.15em] uppercase">
              {item}
            </span>
            <span className="w-1.5 h-1.5 bg-fuchsia-500 rounded-full" />
          </div>
        ))}
      </div>
    </section>
  );
};
